<template>
  <OnboardingInfo size="md" @next="handleClick">
    <template #heading>
      <span class="text-gray-400">Your work, on the record.</span>
      <br />
      <span class="text-gray-800">
        A few questions to tailor Dacr to what you create.
      </span>
    </template>
  </OnboardingInfo>
</template>

<script setup lang="ts">
import OnboardingInfo from '@/features/onboarding/components/OnboardingInfo.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const handleClick = () => {
  completeStep({ step: 1 })

  onboardingStore.goToNextStep()
}
</script>
